import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import ResultsWidget from '../../components/stats/ResultsWidget';
import { getRankingCompetitionMeta } from '../../../api';

  const normalizeDayValue = (value) => {
    if (value == null) return null;
    const normalized = String(value).trim();
    return normalized !== '' ? normalized : null;
    };


export default function ResultsPage() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const competitionIdsParam = searchParams.get('competitionIds') || '';
  const provider = searchParams.get('provider') || '';
  const dayParam = searchParams.get('day');

  const competitionIds = useMemo(
    () =>
      competitionIdsParam
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean),
    [competitionIdsParam]
  );

  const isSingleCompetition = competitionIds.length === 1;
  const firstCompetitionId = competitionIds[0];

  const [discipline, setDiscipline] = useState(null);
  const [title, setTitle] = useState('Résultats');
  const [competitionInfos, setCompetitionInfos] = useState([]);
  const [resolvedDay, setResolvedDay] = useState(null);

  useEffect(() => {
    let ignore = false;

    const loadMeta = async () => {
      if (!firstCompetitionId) {
        if (!ignore) {
          setDiscipline(null);
          setResolvedDay(null);
          setTitle('Résultats');
          setCompetitionInfos([]);
        }
        return;
      }

      try {
        const metas = await Promise.all(
          competitionIds.map(async (competitionId) => {
            const { data } = await getRankingCompetitionMeta(competitionId);
            return data;
          })
        );

        if (ignore) return;

        const firstMeta = metas[0] || {};
        const metaDiscipline = firstMeta?.discipline || null;

        setDiscipline(metaDiscipline);
        setTitle(isSingleCompetition ? 'Résultats' : 'Résultats combinés');
        setCompetitionInfos(
            metas
                .map((meta, index) => ({
                id: competitionIds[index],
                name: meta?.name || '',
                season: meta?.season || '',
                nbDays: meta?.nbDays ?? null,
                defaultDay: meta?.defaultDay ?? null,
                rounds: Array.isArray(meta?.rounds) ? meta.rounds : [],
                }))
                .filter((item) => item.name)
            );

        const parsedDayFromUrl = normalizeDayValue(dayParam);

        if (!isSingleCompetition) {
          setResolvedDay(null);

          if (dayParam) {
            const nextParams = new URLSearchParams(searchParams);
            nextParams.delete('day');
            setSearchParams(nextParams, { replace: true });
          }

          return;
        }

        setResolvedDay(parsedDayFromUrl);
      } catch (error) {
        if (!ignore) {
          setDiscipline(null);
          setResolvedDay(isSingleCompetition ? normalizeDayValue(dayParam) : null);
          setTitle(isSingleCompetition ? 'Résultats' : 'Résultats combinés');
          setCompetitionInfos([]);
        }
      }
    };

    loadMeta();

    return () => {
      ignore = true;
    };
  }, [
    firstCompetitionId,
    competitionIds,
    dayParam,
    searchParams,
    setSearchParams,
    isSingleCompetition,
  ]);

 const handleDayChange = (nextDay) => {
    const nextParams = new URLSearchParams(searchParams);
    const normalizedNextDay = normalizeDayValue(nextDay);

    if (!normalizedNextDay) {
        nextParams.delete('day');
    } else {
        nextParams.set('day', normalizedNextDay);
    }

    setSearchParams(nextParams, { replace: true });
    };

  if (!discipline || competitionIds.length === 0) return null;

  return (
    <ResultsWidget
      provider={provider}
      discipline={discipline}
      competitionIds={competitionIds}
      competitionInfos={competitionInfos}
      day={isSingleCompetition ? resolvedDay : null}
      title={title}
      onNavigate={(url) => navigate(url)}
      onDayChange={isSingleCompetition ? handleDayChange : undefined}
    />
  );
}